import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {openChangePlanModal} from '@Modals/change-plan-modal';
import {ChangePlanStepV2} from '@Panels/change-plan-modal-v2/change-plan-modal-v2.types';

/**
 * Opens the confirmation a canceled subscriber sees before restarting, carrying the plan they asked for on to
 * "Change plan". The redesigned change-plan dialog hosts it as its first step; the classic one has no steps, so
 * behind its flag it keeps its own modal.
 */
export const openResubscribeConfirmationModal = (preselectLevel?: number, preselectDuration?: number): void => {
  if (window.PMW.modernChangePlanDialogEnabled) {
    openChangePlanModal(preselectLevel, preselectDuration, {initialStep: ChangePlanStepV2.RESUBSCRIBE});
    return;
  }
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL,
      panelProps: {preselectLevel, preselectDuration},
    })
  );
};
